import { forwardRef, useMemo } from "react";

import { Icons, TagIntent } from "widgets";

import { mapSequenceTypeToEntityType } from "../../../../app-utils/route.js";
import type { Sequence } from "../../../../graphql.js";
import { Tile, type TileProps } from "@/modules/core/components/Tile.tsx";
import { TileStatus } from "@/modules/core/components/settings.ts";

interface SequenceTileProps extends Pick<TileProps, "footNote" | "type"> {
  sequence: Sequence;
}

const SequenceTile = forwardRef<HTMLDivElement, SequenceTileProps>(function SequenceTile(props, ref) {
  const [title, identifier] = useMemo(() => {
    const title = props.sequence?.name;
    const identifier = props.sequence?.sequenceId;

    return title ? [title, identifier] : [identifier, undefined];
  }, [props.sequence]);

  if (!props.sequence) return null;

  return (
    <Tile
      title={title}
      subtitle={identifier}
      type={props.type ?? "Sequence"}
      to={`/${mapSequenceTypeToEntityType(props.sequence.sequenceGroup?.name)}/${props.sequence.id}`}
      footNote={props.footNote}
      icon={<img src={Icons.Tiles.Sequences} width={24} height={30} />}
      protectionStatus={props.sequence.hidden ? TileStatus.RestrictedVisibility : TileStatus.Normal}
      statusDisplayName={"Sequence"}
      ref={ref}
      tags={
        props.sequence.sequenceType
          ? [{ label: props.sequence.sequenceType, intentColor: TagIntent.Secondary }]
          : undefined
      }
      tooltip={props.sequence.hidden ? undefined : `Database: ${props.sequence.database.mnemonic}`}
    />
  );
});

export { SequenceTile };
